
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import SummaryCard from "./SummaryCard.vue";
import { FETCH_ASSESSMENT_STATS } from "@/store/modules/recruiter/constants";

export default Vue.extend({
  name: "CreateAssessmentHeader",
  components: {
    SummaryCard
  },
  props: {
    saving: {
      type: Boolean,
      default: false
    },
    isFormValid: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters("recruiter", {
      assessmentStats: FETCH_ASSESSMENT_STATS
    }),
    totalAssessmentsValue() {
      return this.assessmentStats?.total_assessments?.count?.toString() || "0";
    },
    totalAssessmentsChangeText() {
      const direction =
        this.assessmentStats?.total_assessments?.change_direction === "up"
          ? "+"
          : "-";
      const percentage = parseFloat(
        this.assessmentStats?.total_assessments?.change_percentage || 0
      );
      return `${direction}${percentage}% ${this.$t(
        "candidate.assessments.create.from-last-month"
      )}`;
    },
    totalAssessmentsChangeType() {
      return this.assessmentStats?.total_assessments?.change_direction === "up"
        ? "positive"
        : "negative";
    },
    totalUsersValue() {
      return this.assessmentStats?.total_users?.count?.toString() || "0";
    },
    totalUsersChangeText() {
      const direction =
        this.assessmentStats?.total_users?.change_direction === "up"
          ? "+"
          : "-";
      const percentage = parseFloat(
        this.assessmentStats?.total_users?.change_percentage || 0
      );
      return `${direction}${percentage}% ${this.$t(
        "candidate.assessments.create.from-last-month"
      )}`;
    },
    totalUsersChangeType() {
      return this.assessmentStats?.total_users?.change_direction === "up"
        ? "positive"
        : "negative";
    },
    assessmentsTakenValue() {
      return this.assessmentStats?.assessments_taken?.count?.toString() || "0";
    },
    assessmentsTakenChangeText() {
      const direction =
        this.assessmentStats?.assessments_taken?.change_direction === "up"
          ? "+"
          : "-";
      const percentage = parseFloat(
        this.assessmentStats?.assessments_taken?.change_percentage || 0
      );
      return `${direction}${percentage}% ${this.$t(
        "candidate.assessments.create.from-last-month"
      )}`;
    },
    assessmentsTakenChangeType() {
      return this.assessmentStats?.assessments_taken?.change_direction === "up"
        ? "positive"
        : "negative";
    },
    averageScoreValue() {
      return `${this.assessmentStats?.average_score?.percentage || 0}%`;
    },
    averageScoreChangeText() {
      const direction =
        this.assessmentStats?.average_score?.change_direction === "up"
          ? "+"
          : "-";
      const percentage = parseFloat(
        this.assessmentStats?.average_score?.change_percentage || 0
      );
      return `${direction}${percentage}% ${this.$t(
        "candidate.assessments.create.from-last-month"
      )}`;
    },
    averageScoreChangeType() {
      return this.assessmentStats?.average_score?.change_direction === "up"
        ? "positive"
        : "negative";
    }
  },
  methods: {
    ...mapActions("recruiter", {
      fetchAssessmentStats: FETCH_ASSESSMENT_STATS
    })
  },
  async mounted() {
    await this.fetchAssessmentStats();
  }
});
